module.exports = __webpack_public_path__ + "static/media/24.211032d0.mp3";